// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__Sz6D8","main":"Layout_main__MpZJp","warning":"Layout_warning__ClUow"};